// Home page texts (en), generated from khotoua-web/en/index.html.
import type { HomeText } from './types';

const en: HomeText = {
  header: {
    khotouaHomeLabel: "Khotoua — home",
    khotouaLogoAlt: "Khotoua logo",
    menuLabel: "Menu",
    mainMenuLabel: "Main menu",
    aboutUs: "About us",
    learningContent: "Learning content",
    features: "Features",
    forSchools: "For schools",
    testimonials: "Testimonials",
    plans: "Plans",
    contact: "Contact",
    arabicCurrent: undefined,
    arabicStyle: {
      color: "inherit",
      textDecoration: "none",
    },
    francaisStyle: {
      color: "inherit",
      textDecoration: "none",
    },
    francaisCurrent: undefined,
    englishStyle: {
      color: "#FFFFFF",
      fontWeight: "800",
      textDecoration: "none",
    },
    englishCurrent: "page",
    arCurrent: undefined,
    arStyle: {
      color: "inherit",
      textDecoration: "none",
    },
    frStyle: {
      color: "inherit",
      textDecoration: "none",
    },
    frCurrent: undefined,
    enStyle: {
      color: "#FFFFFF",
      fontWeight: "800",
      textDecoration: "none",
    },
    enCurrent: "page",
    parentSpaceSoon: "The Parent space is on its way…",
    parentSpace: "Parent space",
    getTheApp: "Get the app",
  },
  hero: {
    learningThroughPlayAges: "\nLearning through play · ages 5 to 12 ",
    wePrepareYourChild: "We prepare your child for exams… ",
    whileProtectingTheirChildhood: "while protecting their childhood and identity.",
    khotouaIsThePerfect: "Khotoua is the perfect companion for primary school children to learn in a fun and engaging way.",
    designedByEducationAnd: "Designed by education and technology experts, following the official school curriculum and the latest teaching approaches, it speaks to Generation Alpha: a generation born with technology… that learns in its language.",
    tryTheFreeDemo: "Try the free demo",
    getTheAppNow: "Get the app now",
    getItOn: "Get it on",
    getItOnAppSoon: "Coming soon on the App Store",
    getItOnAppgallerySoon: "Coming soon on Huawei AppGallery",
    tryItOn: "Try it on",
    theWeb: "the web",
    khotouaSCharacterTheAlt: "Khotoua’s character: the little hero",
    khotouaSThreePillars: "Khotoua’s three pillars",
    learningCulturePlayLabel: "Khotoua’s pillars: learning, culture, play",
    learning: "Learning",
    culture: "Culture",
    play: "Play",
    discoverMoreLabel: "Scroll down to discover more",
    discoverMore: "Discover more",
  },
  about: {
    aboutUs: "About us",
    ltrDir: "ltr",
    aGenerationThatLearns: "A generation that learns differently… deserves a different app.",
    khotouaIsAnEducational: "Khotoua is an educational app  that reinvents primary school learning for children aged 5 to 12.",
    generationAlpha: "Generation Alpha · ",
    designedEspecially: "Designed especially ",
    forGenerationAlpha: "for Generation Alpha",
    aGenerationBornWith: ", a generation born with screens, who learn ",
    throughImages: "through images,",
    movement: "movement",
    andInteraction: "and interaction",
    andWhoNeedExperiences: ", and who need experiences that look like their world and speak to their ",
    curiosity: "curiosity",
    byCombiningPlayWith: "By combining play with augmented reality, Khotoua offers a unique immersive and interactive experience: scenarios full of 2D and 3D games, designed to build cognitive skills in a fun and creative way, while respecting each child’s individuality, so they learn with joy and progress with confidence.",
    augmentedReality: "Augmented reality",
    artificialIntelligence: "Artificial intelligence",
    t2d3dGames: "2D / 3D games",
    personalisedLearning: "Personalised learning",
    childrenLearningWithVirtualAlt: "Children learning with virtual and augmented reality in the schoolyard",
  },
  contents: {
    learningContent: "Learning content",
    whatShallWeDo: "What shall we do today?",
    thisIsHowThe: "This is how the app welcomes your child every day: “My Lessons” at the heart, surrounded by My Games, My Encyclopedia, My Shop and My Discoveries.",
    theKhotouaHomeScreenAlt: "The Khotoua home screen: what shall we do today? My Lessons at the centre, surrounded by My Games, My Encyclopedia, My Shop and My Discoveries",
    homeScreenSpacesLabel: "Home screen spaces",
    myLessons: "My Lessons",
    arabicFrenchEnglishMaths: "Arabic · French · English · Maths · Science",
    myGames: "My Games",
    challengeAndCreativityAdventures: "Challenge and creativity adventures",
    myEncyclopedia: "My Encyclopedia",
    t3dInAugmentedReality: "3D, in augmented reality",
    myShop: "My Shop",
    financialLiteracyLearningTo: "Financial literacy: learning to manage pocket money",
    myDiscoveries: "My Discoveries",
    discoverAndLearnVideos: "Discover and learn: videos, tales and stories",
  },
  demo: {
    insideTheApp: "Inside the app",
    aCompleteSafeWorldDir: "ltr",
    aCompleteSafeWorld: "A complete, safe world… in your child’s hands",
    aSeriousGameWhere: "A serious game where the child is ",
    theHero: "the hero",
    tryTheDemo: "Try the demo",
    khotouaWelcomeScreenWelcomeAlt: "Khotoua welcome screen: Welcome",
    welcome: "Welcome!",
    learningCulturePlayDiscovery: "Learning · Culture · Play · Discovery — a child account in one minute.",
    chooseYourTermScreenAlt: "Choose your term screen",
    inStepWithThe: "In step with the school year",
    term1TheAdventure: "Term 1: the adventure begins · Term 2: the journey continues · Term 3: to the top.",
    chooseYourSchoolAdventureAlt: "Choose your school adventure screen: Arabic, French, English, maths, science, quiz",
    chooseYourSchoolAdventure: "Choose your school adventure",
    arabicFrenchEnglishMaths: "Arabic, French, English, maths, science, quiz.",
    myGamesScreenMathsAlt: "My Games screen: maths game, find the object, memory, addition and football",
    challengeAndCreativityAdventures: "Challenge and creativity adventures",
    mentalMathsMemory2048: "Mental maths, memory, 2048… XP points and coins that keep them motivated.",
    myEncyclopediaScreenInAlt: "My Encyclopedia screen in augmented reality: animals, planets, the human body",
    myEncyclopediaInAugmented: "My Encyclopedia in augmented reality",
    theAnimalWorldA: "The animal world, a trip around the planets, discover the human body… books that come to life.",
    myDiscoveriesScreenVideosAlt: "My Discoveries screen: videos, tales, stories",
    myDiscoveriesWhatWill: "My Discoveries: what will I discover today?",
    videosToWatchAnd: "Videos to watch and learn, podcast tales and new stories to read.",
    videosScreenIllustratedStoriesAlt: "Videos screen: illustrated stories",
    meaningfulIllustratedStories: "Meaningful illustrated stories",
    samiAndTheTwo: "Sami and the two-headed ogre, the old stork, the tricked rooster… values told with joy.",
    characterDesignScreenWithAlt: "Character design screen with points balance and financial literacy",
    designYourCharacterAnd: "Design your character and challenge your friends",
    myBalanceThePrice: "“My balance − the price = what I have left”: financial literacy to manage everyday spending.",
    mapOfTheSustainabilityAlt: "Map of the sustainability journey across continents",
    theSustainabilityJourneyAround: "The sustainability journey around the world",
    continentAfterContinentChildren: "Continent after continent, children discover their planet and learn how to protect it.",
  },
  pedagogy: {
    features: "Features",
    whyDoParentsAnd: "Why do parents and educators choose Khotoua?",
    featuresLabel: "Features",
    contentAlignedWithThe: "Content aligned with the curriculum",
    overcomingLearningDifficulties: "Overcoming learning difficulties",
    augmentedReality: "Augmented reality",
    bloomSTaxonomyOf: "Bloom’s taxonomy of learning objectives",
    whatKhotouaOffersParents: "What Khotoua offers parents",
    yourChildPlaysAnd: "Your child plays… and learns exactly what they study in class.",
    allSubjectsFollowThe: "All subjects follow the official primary school curriculum, lesson by lesson. And when we go further, it is to enrich it, deepen your child’s understanding and broaden their knowledge.",
    behindEveryPieceOf: "Behind every piece of content, a specialised teaching team designs, reviews and checks it, so your child gets reliable, top-quality learning.",
    screenTimeBecomesTime: "Screen time… becomes time for school success.",
    usefulScreenTimeWith: "Useful screen time… with peace of mind",
    parentSpace: "Parent space",
    khotouaYourChildS: "Khotoua: your child’s companion towards easier, more enjoyable learning",
    khotouaStandsOutFor: "Khotoua stands out for its ability to help children with learning difficulties, through activities adapted to their needs, enabling parents and educators to give each child the right support.",
    weKeepImprovingKhotoua: "We keep improving Khotoua so it remains a trusted companion on a unique and fun learning journey, where children discover their abilities, unlock their full potential and overcome their difficulties step by step towards the best results.",
    overcomingDifficultiesIconColouredLabel: "Overcoming difficulties icon: coloured steps the child climbs one by one towards the star",
    theLessonLeavesThe: "The lesson leaves the book… and comes to life before your child’s eyes!",
    withAugmentedRealityLearning: "With augmented reality, learning becomes a real adventure: spinning planets, moving animals, talking characters, all linked to the lesson topics. Your child gets closer, explores them and interacts with them in a three-dimensional world.",
    becauseWhatChildrenLive: "Because what children live for themselves… is never forgotten.",
    myEncyclopediaScreenInAlt: "My Encyclopedia screen in augmented reality: animals, planets, the human body",
    learningContentIsBuilt: "Learning content is built progressively, following Bloom’s taxonomy:",
    theLearnerExploresKnowledge: "The learner explores knowledge, stores it in memory and recalls it.",
    practisesActivitiesThatEnsure: "Practises activities that ensure full understanding of that knowledge.",
    appliesWhatTheyHave: "Applies what they have learned in real-life situations, step by step.",
    analysesTheKnowledgeAnd: "Analyses the knowledge and skills acquired and recombines them to integrate them.",
    evaluatesWhatTheyHave: "Evaluates what they have learned, gives it value and makes an objective judgement.",
    inventsAndCreatesA: "Invents and creates a product based on what they have learned, in content and method.",
    bloomSTaxonomyIconLabel: "Bloom’s taxonomy icon: remember, understand, apply, analyse, evaluate, create",
    remember: "Remember",
    understand: "Understand",
    apply: "Apply",
    analyse: "Analyse",
    evaluate: "Evaluate",
    create: "Create",
    bloomSTaxonomy: "Bloom’s taxonomy",
    whatKhotouaOffersParents2: "What Khotoua offers parents",
    youDonTNeed: "You don’t need to be a teacher… Khotoua is with you.",
    seeTheirProgress: "See their progress:",
    whatTheyHaveDone: " what they have done, what they have mastered and where they need you.",
    trustEveryLesson: "Trust every lesson:",
    contentAlignedWithThe2: " content aligned with the official curriculum, designed by education specialists.",
    followThemFromYour: "Follow them from your own space:",
    theParentSpaceBrings: " the “Parent space” brings everything about your child’s learning together in one place.",
    peaceOfMindAbout: "Peace of mind about their time:",
    aSafeSpaceDesigned: " a safe space designed for children, where every minute counts.",
    youLoveThemWe: "You love them… we help you help them succeed.",
    khotouaMyProfileAndAlt: "Khotoua My Profile and Parent space screen",
    ourTeachingApproach: "Our teaching approach",
    variedLearningContent: "Varied learning content",
    wePrepareYourChild: "We prepare your child for exams… and for life.",
    variedEducationalActivitiesAnd: "Varied educational activities and games",
    linkedToTheOfficial: "linked to the official curriculum, helping them acquire knowledge and use it in everyday life.",
    valuesToGrowUp: "Values to grow up with",
    citizenshipRespectForOthers: "Citizenship, respect for others, human rights and children’s rights.",
    anEyeOnThe: "An eye on the world",
    theyDiscoverTheIssues: "They discover the issues of their time, from protecting the environment to the Sustainable Development Goals, and prepare for their future with confidence.",
    khotoua: "Khotoua,",
    yourChildSWindow: " your child’s window on a changing world… so they can be part of that change.",
    joinUsTodayOn: "Join us today on an exciting and fun learning journey with Khotoua.",
    helpYourChildrenDiscover: "Help your children discover their talents and achieve their dreams through innovative, personalised learning.",
    getTheAppNow: "Get the app now",
    tryTheDemo: "Try the demo",
  },
  schools: {
    forSchoolsAndInstitutions: "For schools and institutions",
    aPlatformThatAdapts: "A platform that adapts to your school’s curriculum",
    withAFlexibleContent: "With a flexible content management system (CMS), the school or the ministry adds its own lessons, languages and local values without any coding. Khotoua partners with Tunisian schools and with a network following the Cambridge system.",
    requestADemoFor: "Request a demo for my school",
    downloadTheBrochure: "Download the brochure",
    customisableContent: "Customisable content",
    modulesAddedToFit: "Modules added to fit each institution’s needs.",
    classTracking: "Class tracking",
    toBeConfirmedA: "[To be confirmed] A tracking dashboard for teachers, by class and by pupil.",
    multilingual: "Multilingual",
    arabicFrenchAndEnglish: "Arabic, French and English.",
    trainingAndSupport: "Training and support",
    weSupportTeachersIn: "We support teachers in bringing the app into the classroom.",
  },
  trust: {
    testimonials: "Testimonials",
    whatDoTeachersSay: "What do teachers say?",
    inTheAgeOf: "In the age of technology, two steps are essential: a step towards knowledge and a step towards technology. That is Khotoua.",
    habibaRais: "Habiba Rais",
    arabicTeacherForBeginners: "Arabic teacher for beginners",
    funAndLearningOn: "Fun and learning on a unique journey to explore the world in an exciting, entertaining way. That is Khotoua, the Tunisian innovation that brings games and learning together… to reinforce key concepts with individual assessment and progress reports. Congratulations!",
    ayaEnnaoui: "Aya Ennaoui",
    primarySchoolTeacher: "Primary school teacher",
    aSolidStepThat: "A solid step that lifts learners towards excellence, builds their knowledge on strong foundations and helps them grow while enjoying learning, through exercises that improve their skills remarkably and lead them to success.",
    najmeddineJarfel: "Najmeddine Jarfel",
    retiredSeniorPrimarySchool: "Retired senior primary school teacher",
    modernInnovativeLearningCapsules: "Modern, innovative learning capsules aligned with the official curriculum, which engage each learner’s particular intelligences and learning styles. They address difficulties and develop pupils’ skills and abilities, and they are very easy to use.",
    mohamedZiraoui: "Mohamed Ziraoui",
    civicEducationTeacher: "Civic education teacher",
    everyBeginningStartsWith: "Every beginning starts with a first step. And Khotoua will be the first step towards excellence.",
    salmaHabibi: "Salma Habibi",
    seniorPrimarySchoolTeacher: "Senior primary school teacher",
    parentsHaveDownloadedKhotoua: "parents have downloaded Khotoua…",
  },
  pricing: {
    plans: "Plans",
    startForFreeAnd: "Start for free… and continue as a family",
    termly6MonthsXLabel: "Subscription length",
    termly: "Termly",
    t6MonthsX: "6 months · [-X%]",
    yearlyX: "Yearly · [-X%]",
    discovery: "Discovery",
    toTryWithYour: "To try with your child",
    t0Tnd: "0 TND",
    theDemo: "The demo",
    freeActivities: " Free activities",
    oneChildProfile: "One child profile",
    theFirstLessonOf: "The first lesson of each subject is free",
    getTheAppAnd: "Get the app and try it now",
    mostPopular: "Most popular",
    family: "Family",
    allOfKhotouaS: "All of Khotoua’s worlds for all siblings",
    termlyPriceTnd: "[Termly price] TND",
    term: "/ term",
    allSixLearningSpaces: "All six learning spaces",
    augmentedRealityAndThe: "Augmented reality and the 3D encyclopedia",
    parentSpaceAndProgress: "Parent space and progress reports",
    upToNumberChild: "Up to [number] child profiles",
    subscribeNow: "Subscribe now",
    schoolsAndInstitutions: "Schools and institutions",
    forClassesNetworksAnd: "For classes, networks and ministries",
    onRequest: "On request",
    licencesPerPupilOr: "Licences per pupil or per institution",
    contentManagementSystemCms: "Content management system (CMS)",
    teacherTrainingAndSupport: "Teacher training and support",
    talkToOurTeam: "Talk to our team",
  },
  contact: {
    contact: "Contact",
    takeTheFirstStep: "Take the first step with Khotoua",
    customerService: "Customer service",
    messageUsOnWhatsapp: "Message us on WhatsApp",
    email: "Email",
    socialMedia: "Social media",
    instagram: "Instagram",
    facebook: "Facebook",
    tiktok: "TikTok",
    linkedin: "LinkedIn",
    youtube: "YouTube",
    requestADemoLabel: "Request a demo",
    requestADemo: "Request a demo",
    iAmA: "I am a",
    parent: " Parent",
    school: "School",
    institutionPartner: " Institution / partner",
    fullName: "Full name",
    phone: "Phone",
    ltrInputStyle: {
      minHeight: "50px",
      borderRadius: "14px",
      border: "1.5px solid #B8C0EA",
      padding: "0 14px",
      textAlign: "left",
    },
    childSSchoolYear: "Child’s school year",
    chooseAYear: "Choose a year…",
    preSchool: "Pre-school",
    primaryYear1: "Primary year 1",
    primaryYear2: "Primary year 2",
    primaryYear3: "Primary year 3",
    primaryYear4: "Primary year 4",
    primaryYear5: "Primary year 5",
    primaryYear6: "Primary year 6",
    schoolName: "School name",
    eGPrivateSchoolPlaceholder: "e.g. … Private School",
    institutionName: "Institution name",
    sendMyRequest: "Send my request",
    fieldsMarkedWith: "Fields marked with ",
    areRequiredYourData: " are required. Your data stays confidential. ",
    privacyPolicy: "Privacy policy",
  },
  footer: {
    yourChildSJourney: "Your child’s journey to success starts with a step… let it be today!",
    getItOn: "Get it on",
    getItOnAppSoon: "Coming soon on the App Store",
    getItOnAppgallerySoon: "Coming soon on Huawei AppGallery",
    tryItOn: "Try it on",
    theWeb: "the web",
    khotouaLogoAlt: "Khotoua logo",
    everyAchievementStartsWith: "Every achievement starts with a step…",
    aboutUsLearningContentLabel: "Links",
    aboutUs: "About us",
    learningContent: "Learning content",
    features: "Features",
    testimonials: "Testimonials",
    termsAndConditionsPrivacyLabel: "Information",
    termsAndConditions: "Terms and conditions",
    privacyPolicy: "Privacy policy",
    contact: "Contact",
    producedBy: "Produced by:",
    dmNovaOfficialWebsiteLabel: "DM NOVA — official website",
    t2026KhotouaDmNova: "© 2026 Khotoua · DM NOVA. All rights reserved.",
    privacySettings: "Privacy settings",
  },
  toast: {
    comingSoon: "Coming soon…",
    theParentSpaceIs: "The Parent space is on its way…",
  },
  whatsapp: {
    whatsappLabel: "Message us on WhatsApp",
    whatsapp: "WhatsApp",
  },
  scrollNext: {
    keepScrollingLabel: "Keep scrolling",
  },
};

export default en;
